import React, { forwardRef } from 'react';
import CustomDescriptionItem from '../../../../components/CustomDescriptionItem';
import { Table, TableColumnType } from 'antd';
import {
  MaterialRequestRecord,
  Movement,
} from '../../../../types/MaterialRequest';

interface MaterialRequestPrintTemplateProps {
  data?: MaterialRequestRecord;
}
const MaterialRequestPrintTemplate = forwardRef<
  HTMLDivElement,
  MaterialRequestPrintTemplateProps
>(({ data }, ref) => {
  const columns: TableColumnType<Movement>[] = [
    {
      title: 'Code',
      dataIndex: 'productCode',
      render: (_text, record) => <span>{record.product?.code}</span>,
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      render: (_text, record) => <span>{record.product?.description}</span>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
    },
    {
      title: 'Product UoM',
      dataIndex: 'productUoM',
      render: (_text, record) => <span>{record.productUom?.description}</span>,
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
    },
    {
      title: 'Request UoM',
      dataIndex: 'requestUoM',
      render: (_text, record) => <span>{record.requestUom?.description}</span>,
    },
    {
      title: 'Request Quantity',
      dataIndex: 'requestQty',
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
    },
  ];

  return (
    <div ref={ref}>
      <div className={'p-4 items-center justify-center'}>
        <div className={'flex items-center justify-between pb-3'}>
          <div className={'flex'}>
            <img src={'/mmd/mmd.png'} alt={'mmd.png'} className={'w-10 h-10'} />
            <span className={'font-semibold text-2xl'}>
              Asia Ceramic Corporation
            </span>
          </div>
          <span className={'font-semibold text-2xl'}>Material Request</span>
        </div>
        <div>
          <div className="flex flex-row justify-between mb-2">
            <CustomDescriptionItem label={'MR'} content={data?.code} />
            <CustomDescriptionItem
              label={'Date'}
              content={data?.requiredDate}
            />
          </div>
          <div className="flex flex-row justify-between mb-2">
            <CustomDescriptionItem
              label={'Source Location'}
              content={data?.location?.description}
            />
            <CustomDescriptionItem
              label={'Destination'}
              content={data?.destination?.description}
            />
          </div>
          <div className="flex flex-row justify-between mb-2">
            <CustomDescriptionItem label={'Purpose'} content={''} />
            <CustomDescriptionItem
              label={'Source Document'}
              content={data?.source}
            />
          </div>
        </div>
        <div>
          <Table
            rowKey={(record) => record.id}
            dataSource={data?.movements}
            columns={columns}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
});
MaterialRequestPrintTemplate.displayName = 'BillOfMaterialPrintTemplate';
export default MaterialRequestPrintTemplate;
